/**
 * How long React Query keeps unused offline caches (gcTime) on both
 * platforms, and how long a persisted cache stays restorable (maxAge).
 * Sized for an extended offline trip.
 *
 * 24 days, not the 30 it reads like: `setTimeout` stores its delay as a
 * 32-bit signed int (max 2_147_483_647 ms ≈ 24.8 days), and a larger delay
 * overflows and fires immediately — which would garbage-collect the offline
 * caches the moment they go unused, the exact opposite of the intent.
 */
export const OFFLINE_GC_TIME_MS = 1000 * 60 * 60 * 24 * 24;
